export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Multiple Industries.47258024.png";